import { any, fromJSX, stateful } from "widgets-for-react";
import { initialLightBoxState } from "./LightBoxState";
import { LightBoxLayout } from "./LightBoxLayout";
export const LightBoxWidget = (props)=>{
    return stateful()((s0)=>any()([
            fromJSX((setState)=>{
                return LightBoxLayout({
                    ...props,
                    ...s0,
                    updateIsOpen: ()=>setState((s)=>({
                                ...s,
                                isOpen: !s.isOpen
                            }))
                });
            })
        ]).map((a)=>a(s0)))(initialLightBoxState(props)).run((_)=>{});
};
